module.exports = __webpack_public_path__ + "static/media/screen-2.d0c043f8.webp";